import { render, staticRenderFns } from "./rightSide.vue?vue&type=template&id=b5b7f988&scoped=true&"
import script from "./rightSide.vue?vue&type=script&lang=js&"
export * from "./rightSide.vue?vue&type=script&lang=js&"
import style0 from "./rightSide.vue?vue&type=style&index=0&id=b5b7f988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b7f988",
  null
  
)

export default component.exports